export default __webpack_public_path__ + "static/media/tt.3fef1396.svg";